import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useFeatureChecks from "../hooks/useFeatureChecks";

const RoleMenuChek = ({ type, children, feature }) => {
  const commonState = useSelector((state) => state.commonReducer);
  const { myProfile, tenantPermissionsInfo } = commonState;
  const [isPermitted, setIsPermitted] = useState(true);
  const { checkRolesAndPermissionsFeature, checkMSOMFeature } =
    useFeatureChecks();

  // const checkMSOMFeature = (menu, isMSOMFeatuePresent) => {
  //   myProfile?.TenantFeatures?.forEach((item) => {
  //     if (menu?.MSOMMenu === item?.Name) isMSOMFeatuePresent = true;
  //   });
  //   return isMSOMFeatuePresent;
  // };

  // const checkRolesAndPermissionsFeature = (
  //   menu,
  //   isRolesAndPermissionFeatuePresent
  // ) => {
  //   // debugger;
  //   const associatedRolesId = myProfile?.AssociatedRoles?.map((data) => {
  //     return data?.RoleID;
  //   });
  //   tenantPermissionsInfo?.forEach((permission) => {
  //     if (menu?.roleMenu === permission?.PermissionName)
  //       associatedRolesId?.forEach((data) => {
  //         if (permission?.AssociatedRoles?.includes(data?.toString())) {
  //           isRolesAndPermissionFeatuePresent = true;
  //         }
  //       });
  //   });
  //   return isRolesAndPermissionFeatuePresent;
  // };

  const isFeatureExist = (menu, isFeatureAvailable) => {
    // debugger;
    if (menu?.roleMenu && menu?.MSOMMenu) {
      //Checking MSOM Feature
      let isMSOMFeatuePresent = false;
      isMSOMFeatuePresent = checkMSOMFeature(menu, isMSOMFeatuePresent);

      //Checking Role and Permissions Feature if that feature is enabled from MSOM
      let isRolesAndPermissionFeatuePresent = false;
      if (isMSOMFeatuePresent) {
        isRolesAndPermissionFeatuePresent = checkRolesAndPermissionsFeature(
          menu,
          isRolesAndPermissionFeatuePresent
        );
      }
      if (isMSOMFeatuePresent && isRolesAndPermissionFeatuePresent)
        isFeatureAvailable?.push(true);
      else isFeatureAvailable?.push(false);
    } else if (menu?.MSOMMenu && !menu?.roleMenu) {
      let isMSOMFeatuePresent = false;
      isMSOMFeatuePresent = checkMSOMFeature(menu, isMSOMFeatuePresent);
      if (isMSOMFeatuePresent) isFeatureAvailable?.push(true);
      else isFeatureAvailable?.push(false);
    } else {
      let isRolesAndPermissionFeatuePresent = false;
      isRolesAndPermissionFeatuePresent = checkRolesAndPermissionsFeature(
        menu,
        isRolesAndPermissionFeatuePresent
      );
      if (isRolesAndPermissionFeatuePresent) isFeatureAvailable?.push(true);
      else isFeatureAvailable?.push(false);
    }
    return isFeatureAvailable;
  };
  useEffect(() => {
    if (feature && myProfile?.TenantFeatures && tenantPermissionsInfo) {
      let isFeatureAvailable = [];
      feature?.forEach((menu) => {
        isFeatureAvailable = isFeatureExist(menu, isFeatureAvailable);
      });

      const allEqual = (arr) => arr?.every((v) => v === arr[0]);
      setIsPermitted(
        (isFeatureAvailable?.length === feature?.length &&
          allEqual(isFeatureAvailable) &&
          isFeatureAvailable[0]) ||
          (isFeatureAvailable?.length === feature?.length &&
            !allEqual(isFeatureAvailable))
          ? true
          : false
      );
    }
  }, [tenantPermissionsInfo, type, myProfile, feature]);

  return isPermitted ? children : <></>;
};
export default RoleMenuChek;
